export const portfolioArray = [
    {
      title: 'AgenteBTC',
      subtitle: 'Bitcoin Exchange and Wallet',
      src: '/media/cards/agentebtc.png',
      alt: 'Agente BTC',
      href: 'https://www.agentebtc.com'
    },
    {
      title: 'The Menu Studio',
      subtitle: 'AR on Food',
      src: '/media/cards/themenustudio.png',
      alt: 'The Menu Studio',
      href: 'https://www.themenustudio.com'
    },
    {
      title: 'SmartLift',
      subtitle: 'Online Personal Training (Coming Soon)',
      src: '/media/cards/smartlift.png',
      alt: 'SmartLift',
      href: 'http://smartlift.oracliom.com'
    },
    {
      title: 'Empathy',
      subtitle: 'Autonomous LMS',
      src: '/media/cards/empathy.png',
      alt: 'Empathy',
      href: 'https://empathy.oracliom.com'
    },
    {
      title: 'Moryc Studio',
      subtitle: 'Design Studio',
      src: '/media/cards/moryc.png',
      alt: 'Moryc Studio',
      href: 'https://www.moryc.com.pl'
    },
    {
      title: 'Bizcaters',
      subtitle: 'Catering Platform',
      src: '/media/cards/bizcaters.png',
      alt: 'Bizcaters',
      href: 'https://www.bizcaters.com'
    },
    {
      title: 'Lavabox',
      subtitle: 'Boxes for Laundry',
      src: '/media/cards/lavabox.png',
      alt: 'Lavabox',
      href: 'https://www.lavaboxlavanderia.com'
    },
    {
      title: 'Bosquo',
      subtitle: 'Meble Company',
      src: '/media/cards/bosquo.png',
      alt: 'Bosquo',
      href: 'http://bosquo.oracliom.com'
    },
  ];